<script>
    import {notifier} from "@beyonk/svelte-notifications";
    import Loader from '../../Loader.svelte';
    import {isMatch} from "lodash-es";
    import {confirm} from '../../Confirmation.svelte';
    import {onMount} from "svelte";

    export let assessment;
    export let assessment_model;
    export let section;

    let prev_section;
    let saved_data;

    let section_data;

    function save() {
        assessment_model.saveSectionResults(section, section_data).then(() => {
            notifier.success("Report Section Saved")
        }).catch(e => {
            notifier.danger("Error Saving Section");
        });
    }

    function load_data(assessment, section) {
        // check for previous section
        if (prev_section != undefined && prev_section !== section) {
            checkUnsaved();
        }

        if (assessment.report_data[section.section_name]) {
            section_data = JSON.parse(JSON.stringify(assessment.report_data[section.section_name]));
        } else {
            if (section.policies) {
                section_data = {
                    policies: section.policies.map((policy) => {
                        return {
                            name: policy.name,
                            policy_provided: "",
                            rag_status: "Green",
                            recommendation: policy.recommendation,
                            references: policy.references
                        }
                    })
                }
            } else {
                section_data = {policies: []};
            }
        }

        saved_data = JSON.parse(JSON.stringify(section_data))

        prev_section = section;
    }
    function save_previous(s, d) {
        assessment_model.saveSectionResults(s, d).then((res) => {
            notifier.success("Report Section Saved");
        }).catch(e => {
            notifier.danger("Error Saving Section");
        })
    }

    function checkUnsaved() {
        if (!isMatch(section_data, saved_data)) {
            // save current variable before moving to new page
            let cache_section = prev_section;
            let cache_data = section_data;
            confirm("The previous section has unsaved changes, would you like to save?", false, {
                yes_button_text: "Save",
                title: "Unsaved Changes"
            }).then(() => {
                save_previous(cache_section, cache_data);
            }).catch(() => null);
        }
    }

    $: load_data($assessment, section);

    onMount(() => checkUnsaved)
</script>

<Loader loading={section_data == undefined}>
    <button class="button is-success is-pulled-right" on:click={save}>Save</button>
    <div>
        <table class="table is-fullwidth is-striped">
            <thead>
                <tr>
                    <th width="350px">Policy Name</th>
                    <th width="250px">Policy Provided</th>
                    <th width="250px">RAG Status</th>
                    <th>Recommendation</th>
                </tr>
            </thead>
            <tbody>
                {#each section_data.policies as policy}
                    <tr>
                        <td>{policy.name}</td>
                        <td>
                            <textarea class="textarea" bind:value={policy.policy_provided}></textarea>
                        </td>
                        <td>
                            <div class="buttons has-addons">
                                <div class="button is-danger" class:is-light={policy.rag_status != "Red"} on:click={() => policy.rag_status = "Red"}>Red</div>
                                <div class="button is-warning" class:is-light={policy.rag_status != "Amber"} on:click={() => policy.rag_status = "Amber"}>Amber</div>
                                <div class="button is-success" class:is-light={policy.rag_status != "Green"} on:click={() => policy.rag_status = "Green"}>Green</div>
                            </div>
                        </td>
                        <td>
                            <textarea class="textarea" bind:value={policy.recommendation}></textarea>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</Loader>